module.exports = [{"id":7386,"values":[{"id":29486,"description":"Control"},{"id":29487,"description":"Alt Control"},{"id":29488,"description":"New Hub Traditional"},{"id":29489,"description":"New Hub Product"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/data/trackedFeatures.json
// module id = 462
// module chunks = 0